/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h } from "@stencil/core";
import { iconManager } from "../../shared";
/**
 * A Stencil component for displaying icons.
 *
 * @example
 * <vx-icon icon="search"/>
 */
// eslint-disable-next-line require-jsdoc
export class VxIcon {
    constructor() {
        this.icon = undefined;
        this.customClass = undefined;
        this.ariaHidden = false;
        this.alt = '';
        this.invert = false;
        this.size = '24px';
        this.filter = undefined;
    }
    /**
     * @inheritDoc
     */
    render() {
        var _a;
        return (h("img", { key: '0a848b94e2a6115aad0ecb47c11e8e2fe8202596', class: {
                [(_a = this.customClass) !== null && _a !== void 0 ? _a : '']: true,
                reinvert: !this.invert,
            }, style: {
                width: this.size,
                height: this.size,
                filter: this.filter ? `${this.filter} !important` : '',
            }, src: iconManager.getIcon(this.icon), "aria-hidden": this.ariaHidden, alt: this.alt }));
    }
    static get is() { return "vx-icon"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-icon.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-icon.css"]
        };
    }
    static get properties() {
        return {
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The name of the icon to display."
                },
                "attribute": "icon",
                "reflect": false
            },
            "customClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An optional custom CSS class to apply to the icon."
                },
                "attribute": "custom-class",
                "reflect": false
            },
            "ariaHidden": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Whether the icon should be hidden from screen readers. Defaults to true."
                },
                "attribute": "aria-hidden",
                "reflect": false,
                "defaultValue": "false"
            },
            "alt": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The alt text for the icon, for screen readers. Defaults to an empty string."
                },
                "attribute": "alt",
                "reflect": false,
                "defaultValue": "''"
            },
            "invert": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Whether to invert the colors of the icon. Defaults to false."
                },
                "attribute": "invert",
                "reflect": false,
                "defaultValue": "false"
            },
            "size": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The size of the icon. Defaults to '24px'."
                },
                "attribute": "size",
                "reflect": false,
                "defaultValue": "'24px'"
            },
            "filter": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An optional CSS filter to apply to the icon."
                },
                "attribute": "filter",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=vx-icon.js.map
